var _polygon, _rect, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "235.8,824.4 172.9,761.5 141.6,767.5 113.7,795.4 201.9,883.6 229.8,855.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 597.1,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 586.9435 6.6379)",
    width: 88.9,
    height: 229.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.3,175.9c-163.5-163.5-377.2-75.4-406.6,54.5s-78.6,369.9-78.6,369.9l60.8,60.8c0,0,240-49.2,369.9-78.6 C896.8,553.2,984.8,339.4,821.3,175.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M427.4,399.1l170.8,170.8c56.4-12,113.8-24.4,158.1-34.3c43.8-9.9,82.4-51.7,98.2-106.4 c21.7-74.8-2.8-154.7-67.2-219.1s-144.2-88.9-219.1-67.2c-54.8,15.8-96.5,54.4-106.4,98.2C451.8,285.3,439.4,342.7,427.4,399.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 601.5,
    y1: 191.9,
    x2: 601.5,
    y2: 191.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652.2,
    y1: 242.7,
    x2: 779.2,
    y2: 369.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 804.6,
    y1: 395,
    x2: 804.6,
    y2: 395
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 678.8,
    y1: 197.9,
    x2: 678.8,
    y2: 197.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 738.7,
    y1: 257.8,
    x2: 768.6,
    y2: 287.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 798.6,
    y1: 317.7,
    x2: 798.6,
    y2: 317.7
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 562.5,
    y1: 224.3,
    x2: 562.5,
    y2: 224.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.9,
    y1: 276.7,
    x2: 746,
    y2: 407.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 772.2,
    y1: 433.9,
    x2: 772.2,
    y2: 433.9
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 526.9,
    y1: 259.9,
    x2: 526.9,
    y2: 259.9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 579.3,
    y1: 312.3,
    x2: 710.3,
    y2: 443.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 736.5,
    y1: 469.6,
    x2: 736.5,
    y2: 469.6
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 514.6,
    y1: 319.3,
    x2: 514.6,
    y2: 319.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 569.7,
    y1: 374.2,
    x2: 652.3,
    y2: 456.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 679.9,
    y1: 483.9,
    x2: 679.9,
    y2: 483.9
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 500.5,
    y1: 376.2,
    x2: 500.5,
    y2: 376.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 560.4,
    y1: 436.1,
    x2: 590.3,
    y2: 466
  }), /*#__PURE__*/React.createElement("line", {
    x1: 620.3,
    y1: 496,
    x2: 620.3,
    y2: 496
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 597.2,
    cy: 822.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M516.4,741.6c0,0,57.6,73.5,0,161.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678,741.6c0,0-57.6,73.5,0,161.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadel);
export default __webpack_public_path__ + "static/media/Padel.b8dcb61e1a7f9ba7a8437a6aca08fc1b.svg";
export { ForwardRef as ReactComponent };